module.exports = __webpack_public_path__ + "static/img/umee.1719b01.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/svg/umee.svg
// module id = duMz
// module chunks = 1